<template>
  <div class="questionnaire-question-content">
    <div class="questionnaire-question-phrase">{{ this.question }}</div>

    <div class="questionnaire-question-question">
      {{ statement }}

      <div>
        <div v-for="proposition of propositions" :key="proposition">
          <div v-if="this.answer != undefined && this.answer.includes(proposition)" :value=proposition class="col-md-8 questionnaire-question-proposition-selected" tabindex="0" v-on:click="focusMultipleCheckbox">
            <div class="questionnaire-question-proposition-choix">
              {{ proposition }}
            </div>
          </div>
          <div v-else :value=proposition class="col-md-8 questionnaire-question-proposition" tabindex="0" v-on:click="focusMultipleCheckbox">
            <div class="questionnaire-question-proposition-choix">
              {{ proposition }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "ExpressionMultipleCheckbox",
  props: {
    question: String,
    statement: String,
  },
  data() {
    return {
      answer: null,
      propositions: null,
    }
  },
  methods: {
    focusMultipleCheckbox: function (event) {
      event.currentTarget.classList.toggle("questionnaire-question-proposition-selected");
      var answersTmp = [];
      var elements = document.getElementsByClassName('questionnaire-question-proposition-selected')
      Array.prototype.forEach.call(elements, function (el) {
        answersTmp.push(el.getAttribute('value'));
      });
      this.answer = answersTmp
    },
  },
  mounted() {
    this.propositions = this.$parent.propositions

    var domainId = this.$parent.domainId
    var indexQuestion = this.$parent.indexQuestion

    UserService.getUserTestQuestions(domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined) this.answer = arrayResponses[index]['answer']

          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
